import { useReactiveVar } from '@apollo/client';
import { Box, Toolbar } from '@mui/material';
import React from 'react';
import { authVar } from 'state/vars';
import Sidebar from 'v2/components/Sidebar/Sidebar';
import Topbar from 'v2/components/Topbar/Topbar';

const Dashboard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const { user } = useReactiveVar(authVar);
  const isAdmin = Boolean(user?.isAdmin);
  const toggleSidebar = () => {
    setOpen((state) => !state);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Topbar toggleSidebar={toggleSidebar} showSidebar={isAdmin} />
      {isAdmin && <Sidebar toggleSidebar={toggleSidebar} open={open} />}
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Dashboard;
